<template>
  <v-dialog scrollable content-class="custom-dialog" ref="dlgAjuan" v-model="dialog" retain-focus max-width="700">
    <template v-slot:activator="{}"></template>

    <v-card>
      <v-card-title class="primary title white--text">Informasi Pendaftaran Tryout!</v-card-title>
      <v-card-text class="my-0 py-0">
        <v-row row class="mt-2">
          <v-col cols="12" class="body-1 my-0 py-0">
            Dengan melakukan pendaftaran <strong>Tryout</strong> ini,
            <ol class="mt-1 pt-1">
              <li>Anda akan mengikuti <i>tryout</i> <strong> sesuai mata pelajaran pada tahap fasilitasi</strong></li>
              <li><strong>Tidak dapat mengubah mata pelajaran</strong> pada tahap fasilitasi.</li>
              <li>Akan mendapatkan jadwal <i>tryout</i> dalam kurun waktu <strong>1x24 jam</strong> setelah melakukan pendaftaran <i>tryout</i></li>
              <li>
                <strong>Bersedia mengikuti jadwal <i>tryout</i> yang sudah ditetapkan</strong>
              </li>
            </ol>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-row no-gutters>
          <v-col cols="12">
            <v-checkbox
              v-model="setuju"
              class="mx-2"
              dense
              color="teal"
              name="setuju"
              label=""
              data-vv-name="setuju"
              data-vv-as="Persetujuan"
              v-validate="'required'"
              :error-messages="errors.collect('form.setuju')"
            >
              <template v-slot:label>
                <div class="body-2 primary--text">
                  Saya sudah membaca, memahami, dan menyetujui persyaratan tersebut
                </div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" align="right">
            <m-button
              class="mx-1"
              color="grey"
              outlined
              :small="$vuetify.breakpoint.smAndDown ? true : false"
              textButton="Batal"
              icon=""
              action="batal"
              @batal="dialog = false"
            ></m-button>
            <m-button
              class="mx-1"
              :disabled="!setuju"
              :small="$vuetify.breakpoint.smAndDown ? true : false"
              textButton="Daftar Tryout"
              icon=""
              action="pilihKelas"
              @pilihKelas="ajuan()"
            ></m-button>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      tahap: null,
      setuju: false
    };
  },
  methods: {
    // eslint-disable-next-line
    open(tahap) {
      this.tahap = tahap;
      this.setuju = false;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    // eslint-disable-next-line
    // ajuan tryout sesuai tahap
    ajuan() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.$store.commit("main/pStart");
          return this.$store
            .dispatch("kelas/enrollTryout", { tahap_id: this.tahap })
            .then(res => {
              this.$store.commit("main/pEnd");
              this.$info("Anda berhasil mendaftar tryout");
              this.dialog = false;
              if (res.error) {
                this.$info("Pendaftaran tryout gagal");
              } else {
                this.$store.dispatch("user/fetch", "reload").catch(e => e);
                this.$info("Pendaftaran tryout berhasil");
              }
              return this.resolve(res);
            })
            .catch(() => {
              this.$store.commit("main/pEnd");
            });
        });
    }
  },
  watch: {
    dialog(n) {
      if (!n && this.reject) {
        this.reject(null);
      }
    }
  },
  computed: {}
};
</script>
<style>
.custom-dialog {
  -webkit-box-shadow: 0px 0px 2px 2px rgb(231, 230, 230);
}
</style>
